var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptionmenuNewWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M338.34,61.37a2.237,2.237,0,1,1,2.237,2.212A2.225,2.225,0,0,1,338.34,61.37Zm0-7.747a2.237,2.237,0,1,1,2.237,2.212A2.225,2.225,0,0,1,338.34,53.622Zm0-7.761a2.237,2.237,0,1,1,2.237,2.212A2.225,2.225,0,0,1,338.34,45.862Z",
    transform: "translate(-328.34 -41.65)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionmenuNewWhite);
export default __webpack_public_path__ + "static/media/optionmenu-new-white.72070c3ec7810f7d6b4493c0c7bb7900.svg";
export { ForwardRef as ReactComponent };